import "./ShowcaseContainer.css";

export const ShowcaseContainer = ({ children }) => {
  return <div className="showcase-container">{children}</div>;
};
